import { FC } from 'react';
import { Button } from 'atoms/Button';
import { NewsletterBlock } from 'pages/StoryBlok/NewsletterBlock';
import { useTranslations } from 'modules/i18n/useTranslations';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import { SocialLinks } from '../../SocialLinks';
import { ColumnContent } from './ColumnContent';
import styles from './styles.module.css';

export const Column: FC<{ index: number; className?: string }> = ({
  index,
  className,
}) => {
  const t = useTranslations();
  const { footer } = useSiteConfig();
  const columnData = footer?.columns?.[index];

  if (!columnData) {
    return null;
  }

  if (index === 4) {
    return (
      <ColumnContent column={columnData} className={className}>
        <div className={styles.socialContainer}>
          <SocialLinks />
          <Button href={t('footer.magazine-link')}>
            {t('footer.magazine')}
          </Button>
        </div>
      </ColumnContent>
    );
  }

  if (index === 5) {
    const blok = columnData?.rows?.find((r) => r.component === 'news_letter');

    return <NewsletterBlock blok={blok} className={styles.column} />;
  }

  return <ColumnContent column={columnData} className={className} />;
};
